import { DateTime } from 'luxon';
import React from 'react';
import { Calendar as BigCalendar, CalendarProps, luxonLocalizer } from 'react-big-calendar';

const localizer = luxonLocalizer(DateTime);

const Calendar = <TEvent extends object = object>(props: Omit<CalendarProps<TEvent>, 'localizer'>) => {
  return <BigCalendar<TEvent> localizer={localizer} views={['month', 'week', 'day']} style={{ minHeight: '80vh' }} {...props} />;
};

export default Calendar;
